// 📄 ملف الفاتورة (PDF) لطلب ارت تاتش - زر يفتح الملف. عرض فقط.
import React from "react";
import { Box } from "@mui/material";
import { FileText } from "lucide-react";
import { P } from "./partnerTheme";

const OrderGallery = ({ order }) => {
  const pdfUrl = typeof order.invoicePdfUrl === "string" && /^https?:/.test(order.invoicePdfUrl) ? order.invoicePdfUrl : "";
  if (!pdfUrl) return null;

  return (
    <Box
      component="a"
      href={pdfUrl}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        mt: 1.5,
        display: "inline-flex",
        alignItems: "center",
        gap: 1,
        px: 1.75,
        py: 1,
        borderRadius: "10px",
        border: `1px solid ${P.line}`,
        color: P.danger,
        textDecoration: "none",
        fontSize: 14,
        fontWeight: 700,
        "&:hover": { background: P.dangerBg },
      }}
    >
      <FileText size={18} />
      فاتورة PDF
    </Box>
  );
};

export default OrderGallery;
